import React from 'react';
import { useQuery } from 'react-query';

import { fetchFromFirebase } from '../../hooks/fetchFromFirebase';

const FooterGemi = ({ collection, id }) => {

    const { isLoading, isError, data, error } = useQuery(['Gemi', collection, id], () => fetchFromFirebase('dealerInfo', 'KD6FHhBRkM5ISPT8qTRZ'));
  
    if (isLoading) {
      return <div>Loading...</div>;
    }
  
    if (isError) {
      return <div>Error: {error.message}</div>;
    }

    return (
        <>
        {data?.dealerGemi && (
            <div className="row margin-top-20">
            <div className="col s12 fs-11 ta-center">
                Αριθμός ΓΕΜΗ.: {data?.dealerGemi}
            </div>
        </div>
        )}
        </>
    )
}

export default FooterGemi;